/* 
 *  Created by SGiri 02/14/2018
 */

import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { MatDialog } from '@angular/material';
import { Dashboard } from '~config/model/dashbord';
import { CommonService } from '~util/common.service';
import { AppUtil } from '~util/app.util';
import { Constants } from '~util/app.constant';
import { DashboardService } from '~config/services/dashboard.service';
import { DialogComponent } from '~config/dashboard-detail/dialog/dialog.component';

@Component({
  selector: 'dashboard-detail',
  templateUrl: './dashboard-detail.component.html',
  styleUrls: ['./dashboard-detail.component.css']
})
export class DashboardDetailComponent implements OnInit {

  dashboards: Dashboard[];
  dashboardId: number = -1;
  disabled: boolean = false;

  gridOptions: GridOptions;
  columnDefs: any[]
  rowData: any[];
  style: {};

  constructor(private service: DashboardService, private util: AppUtil, private dialog: MatDialog, private commonService: CommonService) {
    this.gridOptions = util.getGridOptions('Please select dashbaord');
    this.columnDefs = this.getColumnDef();
    this.style = Constants.gridStyle;
  }

  ngOnInit() {

    this.service.getStandardDashboards().subscribe((data: Dashboard[]) => {
      this.dashboards = data;

      //Save Global dashboard list to service to use it in other components
      this.service.globalDashboards = this.dashboards;
      this.rowData = data;
    });
  }

  getColumnDef() {
    return [
      { headerName: "Dashboard Id", field: "dashboardId" },
      { headerName: "Dashboard Name", field: "dashboardName" },
      { headerName: "Created Date", field: "createdDate", width: 130, valueFormatter: this.util.dateFormatter },
      { headerName: "Modified Date", field: "modifiedDate", width: 130, valueFormatter: this.util.dateFormatter },
      { headerName: "Release Version", field: "releaseVersion", width: 150 }
    ];
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: { dashboard: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dashboards.push(result);
        var newItem = {
          dashboardId: result.dashboardId,
          dashboardName: result.dashboardName,
          createdDate: result.createdDate,
          modifiedDate: result.modifiedDate,
          releaseVersion: result.releaseVersion
        };

        this.gridOptions.api.updateRowData({ add: [newItem] });
      }
    });
  }

  indexChange(selectedIndex) {
    if (selectedIndex == 2) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }

  }

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/dashboard-detail/dashboard-detail.component.ts